import React from 'react';
import './DownloadButton.css';

const DownloadGeoButton = ({ geoJsonData, fileName = "analise_rede.geojson" }) => {
    
    const handleDownload = () => {
        if (!geoJsonData) return;

        // 1. Converte o objeto para string JSON
        const dataStr = JSON.stringify(geoJsonData, null, 2);
        
        // 2. Cria um Blob com o tipo MIME correto para GeoJSON
        const blob = new Blob([dataStr], { type: "application/geo+json" });
        
        // 3. Cria uma URL temporária para o Blob
        const url = window.URL.createObjectURL(blob);
        
        // 4. Cria um elemento "a" invisível para disparar o download
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        
        // 5. Simula o clique e limpa a memória
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    return (
        <button 
            onClick={handleDownload}
            className="btn-download-geo"
            style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
        >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3"/>
            </svg>
            GeoJSON
        </button>
    );
};

export default DownloadGeoButton;